"use strict";
exports.__esModule = true;
exports.defaultCamera = void 0;
exports.defaultCamera = {
    center: { lat: 22.355682, lng: 114.108102 },
    zoom: 11
};
